import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { Icons } from '../../../../shared/helpers/icons';
import { UserDataService } from '../../../../shared/services/userData.service';
import { ISpecialNeedsStudent } from '../../../../shared/models/specialNeeds';
import { SpecialNeedsService } from '../../../../shared/services/specialNeeds.service';

@Component({
  selector: 'special-needs-student-form',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule, SpinnerComponent],
  templateUrl: './student-form.component.html'
})
export class StudentFormComponent implements OnInit {

  icons = Icons;

  @Input() itemToEdit: ISpecialNeedsStudent | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<{ type: string, message: string }>();

  currentBuildingId: string | null = null;
  student: ISpecialNeedsStudent = {};
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private specialNeedsService: SpecialNeedsService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.student = this.itemToEdit ? { ...this.itemToEdit } : {};
  }

  get isEdit(): boolean {
    return !!this.itemToEdit?.id;
  }

  get isValid(): boolean {
    return !!this.student.student_name;
  }

  closeModal(): void {
    this.onClose.emit();
  }

  save(): void {
    if (!this.currentBuildingId || !this.isValid) return;

    const payload: Partial<ISpecialNeedsStudent> = {
      student_name: this.student.student_name,
      grade: this.student.grade,
      homeroom_teacher: this.student.homeroom_teacher,
      type_of_assistance: this.student.type_of_assistance,
    };

    this.loading = true;
    const request$ = this.isEdit
      ? this.specialNeedsService.updateStudent(this.currentBuildingId, String(this.itemToEdit!.id), payload)
      : this.specialNeedsService.createStudent(this.currentBuildingId, payload);

    request$.subscribe({
      next: (response) => {
        this.loading = false;
        if (!response.has_error) {
          this.onSave.emit({ type: 'success', message: this.isEdit ? 'This occurred after updating a student.' : 'This occurred after adding a student.' });
        } else {
          this.onSave.emit({ type: 'unsuccess', message: response.message });
        }
      },
      error: (err) => {
        this.loading = false;
        this.onSave.emit({ type: 'unsuccess', message: err.message });
      }
    });
  }
}
